import { DateTime } from 'luxon'

export function renderTimestamp(maybeTimestamp?: string) {
  return maybeTimestamp ? DateTime.fromISO(maybeTimestamp).toFormat('DD, HH:mm') : '-'
}
